"use client";
import { useGetRecentlyViewedProducts } from "@components/commerce/product/recently-viewed/useRecentlyViewedProducts";
import { AnalyticsListTypes } from "@lib/analytics/analyticsTypes";
import dynamic from "next/dynamic";
import { memo, useMemo } from "react";

// This pulls in the full algoliasearch SDK. Recently-viewed data lives in client storageAdd a comment on  lines R7 to R10Add diff commentMarkdown input:  edit mode selected.WritePreviewAdd a suggestionHeadingBold(command b) command⌘ bBItalic(command i) command⌘ iIQuote(command shift right angle bracket) command⌘ shift⇧ right angle bracket>Code(command e) command⌘ eELink(command k) command⌘ kKUnordered list(command 8) command⌘ 88Numbered list(command shift ampersand) command⌘ shift⇧ ampersand&Task list(command shift l) command⌘ shift⇧ lLMentionReferenceMore itemsSaved repliesAdd FilesPaste, drop, or click to add filesCancelCommentStart a review
// anyway, so there was nothing to server-render here in the first place.
const SearchProductsHitsToCarousel = dynamic(
    () =>
        import("@components/commerce/product/product-carousel/SearchProductHitsToCarousel").then(
            (mod) => mod.SearchProductsHitsToCarousel
        ),
    { ssr: false }
);

export interface RecentProductsProps {
    headline: string;
    theme?: string;
}

const RecentProducts = memo(({ headline, theme }: RecentProductsProps) => {
    const savedProducts = useGetRecentlyViewedProducts();
    const recentProductKeys = useMemo(() => savedProducts.map((p) => p.key), [savedProducts]);

    if (!recentProductKeys.length) return null;

    return (
        <SearchProductsHitsToCarousel
            theme={theme}
            skus={recentProductKeys}
            headline={headline}
            assistiveMessage="Recent Products"
            carouselType={AnalyticsListTypes.recentlyViewed}
        />
    );
});

RecentProducts.displayName = "RecentProducts";

export default RecentProducts;
